// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

const isNull = (v: unknown): v is null => v === null;
const isBoolean = (v: unknown): v is boolean => typeof v === "boolean";

const isDimensionActionField = objectOf({
  name: string,
  value: anyOf(string, number, isBoolean, isNull),
});

export const isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      key: string,
      fields: arrayOf(isDimensionActionField),
      created_at: string,
      updated_at: string,
    })
  ),
});
